export interface NavItem { path: string; label: string; icon: string }
export interface NavGroup { id: string; label: string; items: NavItem[] }

export const navGroups: NavGroup[] = [
  { id: 'overview', label: 'Overview', items: [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/analytics', label: 'Analytics', icon: '📈' },
  ] },
  { id: 'catalogue', label: 'Books & Catalogue', items: [
    { path: '/books', label: 'Books', icon: '📚' },
    { path: '/corrections', label: 'Corrections', icon: '✏️' },
    { path: '/corrections/sinhala', label: 'Sinhala Corrections', icon: 'සි' },
    { path: '/data-directory', label: 'Data Directory', icon: '🗂️' },
  ] },
  { id: 'safety', label: 'Safety & Moderation', items: [
    { path: '/content', label: 'Content', icon: '🚩' },
    { path: '/wisdom-reports', label: 'Wisdom Reports', icon: '🛡️' },
    { path: '/official-circles/community', label: 'Community moderation', icon: '🛡️' },
    { path: '/exchange-disputes', label: 'Exchange disputes', icon: '🔄' },
  ] },
  { id: 'people', label: 'People & Support', items: [
    { path: '/users', label: 'Users', icon: '👥' },
    { path: '/authors', label: 'Authors', icon: '✍️' },
    { path: '/feedback', label: 'Feedback & Ideas', icon: '💬' },
  ] },
  { id: 'commerce', label: 'Commerce', items: [
    { path: '/sellers', label: 'Sellers', icon: '🏪' },
    { path: '/marketplace', label: 'Marketplace', icon: '🛒' },
    { path: '/subscriptions', label: 'Subscriptions', icon: '💳' },
  ] },
  { id: 'publishing', label: 'Publishing & Learning', items: [
    { path: '/official-circles', label: 'Official Circles', icon: '◎' },
    { path: '/stories', label: 'Stories', icon: '🏆' },
    { path: '/trivia', label: 'Trivia', icon: '🎯' },
    { path: '/brain', label: 'Brain Training', icon: '🧠' },
  ] },
  { id: 'system', label: 'System', items: [
    { path: '/flags', label: 'Feature Flags', icon: '⚑' },
    { path: '/notifications', label: 'Notifications', icon: '🔔' },
    { path: '/audit-log', label: 'Audit Log', icon: '📋' },
    { path: '/account/security', label: 'Account Security', icon: '🔐' },
  ] },
];

export function pageTitle(path: string): string {
  return navGroups.flatMap(group => group.items).find(item => item.path === path)?.label || 'Admin Panel';
}
